module.exports = __webpack_public_path__ + "videos/be-creator-video.8f61853.mp4";